import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { AuthData } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: AuthData) =>
    $actions.user.signInPrimary(dispatch, { values }),
  );
};
